import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import img1 from "../../assets/img1.png"; 
import img2 from "../../assets/img2.png"; 
import img3 from "../../assets/img3.png"; 
import img4 from "../../assets/img4.png"; 
import img5 from "../../assets/img5.png"; 
import img6 from "../../assets/img6.png"; 
import img7 from "../../assets/img7.png"; 
import img8 from "../../assets/img8.png"; 
import img9 from "../../assets/img9.png"; 


const ButterflyGroups = () => {
  const partnerLogos = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <section className="bg-white px-4 sm:px-6 md:px-12 py-8 sm:py-10 md:py-12"  data-aos="fade-up">
      
      {/* Heading */}
      <h1 className="text-3xl sm:text-4xl md:text-[40px] text-center font-bold text-[#172633] mb-4 uppercase">
        BUTTERFLY GROUPS
      </h1>

      {/* Description */}
      <p className="text-gray-700 text-center max-w-3xl sm:max-w-4xl mx-auto mb-8 sm:mb-10 leading-relaxed text-sm sm:text-base">
        At <span className="font-semibold">Butterfly Groups</span>, transformation is not just a mission—
        it’s our identity. From nurturing human potential to enriching communities, every endeavor is 
        dedicated to fostering sustainable wellness. We are committed to creating meaningful impact, 
        improving the quality of life for individuals and communities alike.
      </p>

      {/* Scrolling Partner Logos */}
      <section data-aos="fade-up" className="bg-white pb-6 text-center">
        <div className="overflow-hidden relative rounded-lg">
          <div className="flex w-max animate-scrollLeft hover:[animation-play-state:paused] space-x-4">
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Partner Logo ${index}`}
                className="h-24 sm:h-32 md:h-40 w-auto transition duration-300 rounded-lg hover:scale-105 object-contain"
              />
            ))}
          </div>
        </div>
      </section>


      {/* Paragraphs */}
      <div className="text-gray-700 max-w-3xl sm:max-w-5xl mx-auto space-y-4 sm:space-y-5 leading-relaxed text-center text-sm sm:text-base">
        <p>
          Born from a vision to create impact across essential aspects of human life, 
          <span className="font-semibold"> Butterfly Groups</span> integrates a diverse range of services 
          that holistically address the many dimensions of life. Educational, financial, social, and 
          emotional well-being are the cornerstones of our initiatives.
        </p>
        <p>
          Whether you are a startup seeking a reliable HR partner, a family building their financial 
          foundation, or an individual striving for personal growth, we are here to walk beside you. 
          In every project we undertake, passion meets purpose.
        </p>
        <p>
          Journeying towards wellness, <span className="font-semibold">Butterfly Groups</span> brings 
          people together and builds bridges to a brighter tomorrow.
        </p>
        <p>
          Our mission is driven by the belief that transformation is not a destination, 
          but a continuous journey. With an unwavering dedication to creating a butterfly effect 
          of positive change, we empower individuals and organizations to flourish, ensuring 
          focused attention and exceptional results.
        </p>
      </div>

    </section>
  );
};

export default ButterflyGroups;
